import React from "react"

import { liteClient as algoliasearch } from "algoliasearch/lite"
import { InstantSearch } from "react-instantsearch"
import CustomSearch from "../el/searchbox"
import CustomResults from "../el/searchhitswrapper"

//api stuffs
const searchClient = algoliasearch(
  "XDOED1GAN4",
  "eaf49548dc9cac4a8f4116796b2b7023",
)

// main search component look in components/el/search... for included elements
const Search = () => {
  return (
    <div className="flex flex-1 items-center justify-center px-2 lg:ml-6 lg:justify-end">
      <div className="relative w-full max-w-lg lg:max-w-xs">
        <InstantSearch
          indexName="dev_PRODUCTS"
          searchClient={searchClient}
          stalledSearchDelay={10}
        >
          {/* Input goes here */}
          <CustomSearch />
          {/* hits container here */}
          <CustomResults />
        </InstantSearch>
      </div>
    </div>
  )
}

export default Search
